"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootClasses = exports.inputClasses = exports.TextField = void 0;
var _react = require("react");
var _base = require("@mui/base");
var _Input = require("@mui/base/Input");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _classes = require("../../common/classes");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["helperText", "label", "id", "size", "error", "startDecorator", "endDecorator", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// pass label straight through without classes if it's a reactnode

var rootClasses = exports.rootClasses = (0, _classVarianceAuthority.cva)(['flex', 'outline', 'outline-1', 'rounded-lg', 'my-2', 'w-full', 'transition-[outline-color]', 'duration-200', 'focus-within:outline-2'], {
  variants: {
    multiline: {
      "true": ['h-[5.5rem]', 'resize-y', 'overflow-auto', 'items-start'],
      "false": ['items-center']
    },
    disabled: {
      "true": ['text-black/40', 'bg-gray-100', 'opacity-100', 'cursor-not-allowed'],
      "false": ['bg-white']
    },
    error: {
      "true": ['outline-danger'],
      "false": ['outline-gray-200']
    }
  },
  compoundVariants: [{
    disabled: false,
    error: false,
    className: ['hover:outline-gray-700', 'focus-within:outline-primary', 'hover:focus-within:outline-primary']
  }, {
    disabled: false,
    error: true,
    className: ['hover:outline-danger', 'focus-within:outline-danger', 'hover:focus-within:outline-danger']
  }]
});
var inputClasses = exports.inputClasses = (0, _classVarianceAuthority.cva)(['appearance-none', 'text-normal', 'font-medium', 'enabled:text-gray-700', 'placeholder:text-black/30', 'placeholder-shown:truncate', 'focus:outline-none', 'flex-grow', 'resize-none', 'leading-7'], {
  variants: {
    disabled: {
      "true": ['cursor-not-allowed'],
      "false": []
    },
    size: {
      sm: ['py-2', 'px-5'],
      md: ['py-4', 'px-5']
    },
    startDecorator: {
      "true": [],
      "false": []
    },
    endDecorator: {
      "true": [],
      "false": []
    }
  },
  compoundVariants: [{
    size: 'sm',
    startDecorator: true,
    className: ['pl-2']
  }, {
    size: 'sm',
    endDecorator: true,
    className: ['pr-2']
  }, {
    size: 'md',
    startDecorator: true,
    className: ['pl-2']
  }, {
    size: 'md',
    endDecorator: true,
    className: ['pr-2']
  }]
});
var decoratorClasses = (0, _classVarianceAuthority.cva)([], {
  variants: {
    multiline: {
      "true": ['pt-5'],
      "false": []
    },
    position: {
      left: ['pl-5'],
      right: ['pr-5']
    }
  }
});

/**
 * Text Field - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/inputs-textfield) | [DSM](https://sharphealthcare.notion.site/Inputs-4a77e695a529479fa701e2f3dcdc47e7#effba4e1d9304ba19046b04cdfe8d97b)
 */
var TextField = exports.TextField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var helperText = _ref.helperText,
    label = _ref.label,
    id = _ref.id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    error = _ref.error,
    startDecorator = _ref.startDecorator,
    endDecorator = _ref.endDecorator,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var generatedID = (0, _react.useId)();
  var inputID = id !== null && id !== void 0 ? id : generatedID;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _helpers.cn)(className),
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      htmlFor: inputID,
      className: (0, _helpers.cn)((0, _classes.labelClasses)({
        disabled: Boolean(props.disabled),
        error: Boolean(error)
      })),
      children: label
    }), props.required && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "aria-label": "required",
      className: (0, _helpers.cn)((0, _classes.requiredClasses)({
        disabled: Boolean(props.disabled)
      })),
      children: "*"
    }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _helpers.cn)((0, _classes.helperClasses)({
        disabled: Boolean(props.disabled),
        className: 'mb-3'
      })),
      children: helperText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.ClassNameConfigurator, {
      disableDefaultClasses: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, _objectSpread(_objectSpread({}, props), {}, {
        ref: ref,
        error: Boolean(error),
        id: inputID,
        slotProps: {
          root: {
            className: (0, _helpers.cn)(rootClasses({
              error: Boolean(error),
              disabled: Boolean(props.disabled),
              multiline: Boolean(props.multiline)
            }))
          },
          input: {
            className: (0, _helpers.cn)(inputClasses({
              size: size,
              disabled: props.disabled,
              startDecorator: Boolean(startDecorator),
              endDecorator: Boolean(endDecorator)
            }))
          }
        },
        startAdornment: startDecorator && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: decoratorClasses({
            multiline: props.multiline,
            position: 'left'
          }),
          children: startDecorator
        }),
        endAdornment: endDecorator && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: decoratorClasses({
            multiline: props.multiline,
            position: 'right'
          }),
          children: endDecorator
        })
      }))
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _helpers.cn)((0, _classes.errorClasses)()),
      children: error
    })]
  });
});